/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FacilityGroupNotificationSetting } from '../../models/facility-group-notification-setting';

export interface FindByFacilityGroupId$Params {
  facilityGroupId: number;
}

export function findByFacilityGroupId(http: HttpClient, rootUrl: string, params: FindByFacilityGroupId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FacilityGroupNotificationSetting>>> {
  const rb = new RequestBuilder(rootUrl, findByFacilityGroupId.PATH, 'get');
  if (params) {
    rb.path('facilityGroupId', params.facilityGroupId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<FacilityGroupNotificationSetting>>;
    })
  );
}

findByFacilityGroupId.PATH = '/api/facilityGroup/notification/setting/facilityGroupId/{facilityGroupId}';
